import { router } from '@inertiajs/react';
import axios from 'axios';
import { toast } from 'sonner';

const getCSRFToken = () => {
  if (typeof document !== 'undefined')
    return (
      document.querySelector('[name="csrf-token"]')?.getAttribute('content') ||
      ''
    );
  return '';
};

export const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  config.headers['X-CSRF-Token'] = getCSRFToken();
  return config;
});

// Axios handles only auth(401) and Network errors. The rest will be handled by React Query.
// Refer to queryErrorHandler.tsx file for Application Level Errors
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401) {
      toast.error('Session expired. Please login again');
      // window.location.href = '/session/new';
      router.visit('/session/new', { replace: true });
    } else if (!error.response) {
      toast.error('Network error. Please check your connection.');
    }
    return Promise.reject(error);
  }
);
